import { useMutation } from 'react-query';
import { redeemGuestForm, submitGuestForm } from './api';

/** Exchange the magic-link token for a session, the definition and the answers so far. */
export const useRedeemGuestForm = () =>
  useMutation((linkToken: string) => redeemGuestForm(linkToken));

/**
 * Finalize the form. Terminal server-side: the invitation is consumed.
 *
 * The session token is a call-time argument rather than a captured one. Binding it at hook level
 * meant the submit carried whichever token the render held, which is the wrong one exactly when it
 * matters — after the preceding save recovered a lapsed session. It also needed casting away two
 * `undefined`s, and a cast is how a request ends up sent as `Bearer undefined` instead of refused.
 */
export const useSubmitGuestForm = (formRef: string) =>
  useMutation((sessionToken: string) => submitGuestForm(formRef, sessionToken));
